import { render, staticRenderFns } from "./deviceBenchmark.vue?vue&type=template&id=e38c6470&scoped=true&"
import script from "./deviceBenchmark.vue?vue&type=script&lang=js&"
export * from "./deviceBenchmark.vue?vue&type=script&lang=js&"
import style0 from "./deviceBenchmark.vue?vue&type=style&index=0&id=e38c6470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38c6470",
  null
  
)

export default component.exports